<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
              step: 0
            }
        },
        /////////////////////////////////////////////////////
        // Mounted
        /////////////////////////////////////////////////////
        mounted() {
            // $('html, body').animate({ scrollTop: $('body').position().top + 650 }, 'slow');
            this.step = parseInt(window.top.location.hash.replace('#', ''))
            window.top.addEventListener('hashchange', this.stepchange, false);
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            broadcastEvent(msg) {
                let event = new CustomEvent('myEvent', {detail: msg})
                window.top.document.dispatchEvent(event)
            },
            stepchange() {
                this.step = parseInt(window.top.location.hash.replace('#', ''))
            }
        }
    }

</script>
